'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var Vue = _interopDefault(require('vue'));
var Tap = _interopDefault(require('../tap'));
var device = require('./device');
var create = require('./create');
var createComponent = require('./create-component');
var createSimpleFc = require('./create-simple-fc');
var dom = require('./dom');

Vue.use(Tap);
var hasProp = function (prop) { return prop || prop === ''; };

Object.keys(device).forEach(function (key) { exports[key] = device[key]; });
Object.keys(create).forEach(function (key) { exports[key] = create[key]; });
Object.keys(createComponent).forEach(function (key) { exports[key] = createComponent[key]; });
Object.keys(createSimpleFc).forEach(function (key) { exports[key] = createSimpleFc[key]; });
Object.keys(dom).forEach(function (key) { exports[key] = dom[key]; });
exports.hasProp = hasProp;
